import $ from "jquery";

const accordionSelector = ".component-accordion-element";

class Accordion {

    constructor(element) {
        this.element = element;
        this.$element = $(element);

        this.panel = this.$element.find(`${accordionSelector}__inner-blocks`).first()[0];

        this.isOpen = this.$element.hasClass("open");

        this.attachEvents();
    }

    attachEvents() {
        this.$element.find(`${accordionSelector}__title`).click(() => {
            this.toggle();
        })
    }

    toggle() {
        if(this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.$element.addClass("open");
        // this.panel.style.maxHeight = this.panel.scrollHeight + "px";
        this.isOpen = true;

        document.dispatchEvent(new Event('pat-changeheight'));
    }

    close() {
        this.$element.removeClass("open");
        // this.panel.style.maxHeight = "0px";
        this.isOpen = false;

        document.dispatchEvent(new Event('pat-changeheight'));
    }

}

export default function() {
    $(accordionSelector).each(function() {
        new Accordion(this);
    });
}
